import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import {GooglePlaceReview} from '../../../../models/hub/hub.google.place.data';
import {VisitorApiService} from "../../../../services/visitor.api.service";

@Component({
    selector: 'ig-google-place-reviews',
    templateUrl: './google.place.reviews.component.html',
    styleUrls: ['./google.place.reviews.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class GooglePlaceReviewsComponent implements OnChanges {
    @Input() public reviews: GooglePlaceReview[];
    @Input() public googleLink = null;
    @Input() public columns = 1;
    @Input() public placeId = '';
    public messageLength = 550;
    public stars = [];
    public rows = [];
    public loading = false;
    @Output() onGotoGoogleList: EventEmitter<any> = new EventEmitter();

    constructor(private visitorApiService: VisitorApiService) {
    }

    public ngAfterContentInit() {
        this.setReviews();
    }

    private setReviews() {
        if (this.reviews && this.reviews.length) {
            this.reviews = this.reviews.filter(x => x.rating && +x.rating >= 3);
            this.reviews.forEach(x => {
                x.stars = [];
                let times = Math.floor(x.rating);
                for (let i = 0; i < times; i++) {
                    x.stars.push({});
                }
            });

            this.setReviewColumn();
        } else {
            this.reviews = [];
            this.rows = [];
        }
        this.loading = false;
    }

    public sortReview(sort: 'recency' | 'relevancy' | 'highest_rating' | 'lowest_rating') {
        this.loading = true;
        this.visitorApiService.getGooglePlaceReviews(this.placeId, sort).subscribe(reviews => {
            // only show rating >= 3 places, +x.rating is to parse string rating to number
            reviews = sort !== 'lowest_rating' ? reviews.filter(x => +x.rating >= 3) : reviews;
            this.reviews = reviews;
            this.setReviews();
        });
    }

    public gotoGoogleList() {
        if (this.googleLink) {
            window.open(this.googleLink, '_blank');
        }
        this.onGotoGoogleList.emit();
    }


    // if facebook place is matched and its posts are loaded, then show 1 column google reviews (here the this.columns will be 1)
    // latest: as we would like the users to login with FB first before matching a google place with FB place, which means the FB login/post section will always be shown, so the column will always be 1
    ngOnChanges(changes: SimpleChanges): void {
        this.setReviewColumn();
    }

    private setReviewColumn() {
        let col = [];
        this.rows = [];
        if (this.reviews && this.reviews.length) {
            this.reviews = this.reviews.filter(x => !!x.text);
            this.reviews.forEach((x, i) => {
                if (this.columns === 1) {
                    col.push(x);
                    this.rows.push(col);
                    col = [];
                } else {
                    if (i && i % this.columns === 0) {
                        this.rows.push(col);
                        col = [];
                    }
                    col.push(x);
                    if (i === this.reviews.length - 1) {
                        // add blank boxes to the last row
                        if (col.length < this.columns) {
                            for (let a = 0; a < this.columns - col.length; a++) {
                                col.push(new GooglePlaceReview());
                            }
                        }
                        this.rows.push(col);
                    }
                }
            });
        }
    }

    public getTime(review) {
        return review.relative_time_description || new Date(review.dateTimeISOString).toLocaleString();
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/google.place/google.place.reviews/google.place.reviews.component.ts